<template>
  <div>
    <quillEditor v-model="myContent"
                 ref="myTextEditor"
                 :options="editorOption">
      <div :id="toolbarid" slot="toolbar">
        <span class="ql-formats"><button type="button" class="ql-bold"></button></span>
        <span class="ql-formats"><button type="button" class="ql-italic"></button></span>
        <span class="ql-formats"><button type="button" class="ql-underline"></button></span>
        <span class="ql-formats"><button type="button" class="ql-strike"></button></span>
        <span class="ql-formats"><button type="button" class="ql-blockquote"></button></span>
        <span class="ql-formats"><button type="button" class="ql-code-block"></button></span>
        <span class="ql-formats"><button type="button" class="ql-header" value="1"></button></span>
        <span class="ql-formats"><button type="button" class="ql-header" value="2"></button></span>
        <span class="ql-formats"><button type="button" class="ql-list" value="ordered"></button></span>
        <span class="ql-formats"><button type="button" class="ql-list" value="bullet"></button></span>
        <span class="ql-formats"><button type="button" class="ql-script" value="sub"></button></span>
        <span class="ql-formats"><button type="button" class="ql-script" value="super"></button></span>
        <span class="ql-formats"><button type="button" class="ql-indent" value="-1"></button></span>
        <span class="ql-formats"><button type="button" class="ql-indent" value="+1"></button></span>
        <span class="ql-formats"><button type="button" class="ql-direction" value="rtl"></button></span>
        <span class="ql-formats"><select class="ql-size">
        <option value="small"></option>
        <option selected></option>
        <option value="large"></option>
        <option value="huge"></option>
      </select></span>
        <span class="ql-formats"><select class="ql-color">
        <option selected="selected"></option>
        <option value="#e60000"></option>
        <option value="#ff9900"></option>
        <option value="#ffff00"></option>
        <option value="#008a00"></option>
        <option value="#0066cc"></option>
        <option value="#9933ff"></option>
        <option value="#ffffff"></option>
        <option value="#facccc"></option>
        <option value="#ffebcc"></option>
        <option value="#ffffcc"></option>
        <option value="#cce8cc"></option>
        <option value="#cce0f5"></option>
        <option value="#ebd6ff"></option>
        <option value="#bbbbbb"></option>
        <option value="#f06666"></option>
        <option value="#ffc266"></option>
        <option value="#ffff66"></option>
        <option value="#66b966"></option>
        <option value="#66a3e0"></option>
        <option value="#c285ff"></option>
        <option value="#888888"></option>
        <option value="#a10000"></option>
        <option value="#b26b00"></option>
        <option value="#b2b200"></option>
        <option value="#006100"></option>
        <option value="#0047b2"></option>
        <option value="#6b24b2"></option>
        <option value="#444444"></option>
        <option value="#5c0000"></option>
        <option value="#663d00"></option>
        <option value="#666600"></option>
        <option value="#003700"></option>
        <option value="#002966"></option>
        <option value="#3d1466"></option>
      </select></span>
        <span class="ql-formats"> <select class="ql-background">
        <option value="#000000"></option>
        <option value="#e60000"></option>
        <option value="#ff9900"></option>
        <option value="#ffff00"></option>
        <option value="#008a00"></option>
        <option value="#0066cc"></option>
        <option value="#9933ff"></option>
        <option selected="selected"></option>
        <option value="#facccc"></option>
        <option value="#ffebcc"></option>
        <option value="#ffffcc"></option>
        <option value="#cce8cc"></option>
        <option value="#cce0f5"></option>
        <option value="#ebd6ff"></option>
        <option value="#bbbbbb"></option>
        <option value="#f06666"></option>
        <option value="#ffc266"></option>
        <option value="#ffff66"></option>
        <option value="#66b966"></option>
        <option value="#66a3e0"></option>
        <option value="#c285ff"></option>
        <option value="#888888"></option>
        <option value="#a10000"></option>
        <option value="#b26b00"></option>
        <option value="#b2b200"></option>
        <option value="#006100"></option>
        <option value="#0047b2"></option>
        <option value="#6b24b2"></option>
        <option value="#444444"></option>
        <option value="#5c0000"></option>
        <option value="#663d00"></option>
        <option value="#666600"></option>
        <option value="#003700"></option>
        <option value="#002966"></option>
        <option value="#3d1466"></option>
      </select></span>
        <span class="ql-formats">
        <select class="ql-align">
        <option selected="selected"></option>
        <option value="center"></option>
        <option value="right"></option>
        <option value="justify"></option>
      </select>
      </span>
        <span class="ql-formats"><button type="button" class="ql-clean"></button></span>
        <span class="ql-formats"><button type="button" class="ql-link"></button></span>
        <!--图片按钮点击事件-->
        <span class="ql-formats"><button type="button" @click="imgClick">
        <svg viewBox="0 0 18 18"> <rect class="ql-stroke" height="10" width="12" x="3" y="4"></rect> <circle class="ql-fill" cx="6" cy="7" r="1"></circle> <polyline class="ql-even ql-fill" points="5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12"></polyline> </svg>
      </button></span>
      </div>
    </quillEditor>
    <!--<span class="ql-formats"><select class="ql-header" >
        <option value="1"></option>
        <option value="2"></option>
        <option value="3"></option>
        <option value="4"></option>
        <option value="5"></option>
        <option value="6"></option>
        <option selected="selected"></option>
      </select></span>
      <span class="ql-formats"><select class="ql-font">
           <option selected="selected"></option>
           <option value="serif"></option>
           <option value="monospace"></option>
         </select></span>
      <span class="ql-formats"><button type="button" class="ql-video"></button></span>-->
  </div>
</template>


<script>
  import {editorUpload} from '@/api/attachment'
  import {quillEditor} from 'vue-quill-editor'
  import 'quill/dist/quill.snow.css'
  import Quill from 'quill'
  import {ImageDrop} from 'quill-image-drop-module'
  import ImageResize from 'quill-image-resize-module'

  Quill.register('modules/imageResize', ImageResize)
  Quill.register('modules/imageDrop', ImageDrop)

  export default {
    name: "quillEditor1",
    data() {
      return {
//        msg: '这个是user模板页',
        editorOption: {
          placeholder:'请填写内容...',
          modules: {
            toolbar: '#'+this.toolbarid,
            imageDrop: true,
            imageResize: {}
          },
          /*显示裁切控件*/
          showCrop:false
        },
        myContent:this.content,
        photoUrl : "" ,        // 上传图片地址
        fullscreenLoading:false,
      }
    },
    props: {
      /*编辑器的内容*/
      toolbarid: {
        type: String,
        default:'toolbar'
      },
      /*编辑器的内容*/
      content: {
        type: String
      },
      /*上传图片的file控件name*/
      fileName: {
        type: String
      },
      /*图片大小
      maxSize:{
        type:Number,
        default:5128//kb
      },*/
      imgMaxSize: {//图片的最大宽度 高度
        default: 1024
      },
      /*使用使用裁切*/
      canCrop:{
        type:Boolean,
        default:false
      },
      /*裁切的最小尺寸*/
      width:{
        type:Number,
        default:200
      },
      /*裁切的最小尺寸*/
      height:{
        type:Number,
        default:200
      }
    },
    methods: {
      onChange(){
        this.$emit('input', this.content)
      },
      /*选择上传图片切换*/
      onFileChange(e) {
        var fileInput = e.target;
        if (fileInput.files.length == 0) {
          return;
        }
        // if (fileInput.files[0].size > 1024 * 1024 * this.maxSize) {
        //   alert('图片过大');
        //   return;
        // }
        this.DrawImage(fileInput.files[0]);

      },
      DrawImage(file) {
        // 压缩图片需要的一些元素和对象
        var self=this;
        if(self.editor.getSelection()==null){
          self.editor.focus();
        }
        var reader = new FileReader(),
          img = new Image();
        // 选择的文件是图片
        if (file.type.indexOf("image") == 0) {
          reader.readAsDataURL(file);
        } else {
          return;
        }

        // 文件base64化，以便获知图片原始尺寸
        reader.onload = function (e) {
          img.src = e.target.result;
        };

        // 缩放图片需要的canvas
        var canvas = document.createElement('canvas');
        var context = canvas.getContext('2d');
        // base64地址图片加载完毕后
        img.onload = function () {
          // 图片原始尺寸
          var originWidth = this.width;
          var originHeight = this.height;
          // 最大尺寸限制
          var maxWidth = self.imgMaxSize,
            maxHeight = self.imgMaxSize;
          if(maxWidth>=originWidth){//&&maxHeight>=originHeight){
            editorUpload(file).then(response=>{
              //console.log(response);
              self.editor.insertEmbed(self.editor.getSelection().index, 'image', response.data.url);
            })
            return;
          }else {
            // 目标尺寸
            var targetWidth = originWidth,
              targetHeight = originHeight;

            // if (originWidth > maxWidth || originHeight > maxHeight) {
            //   if (originWidth / originHeight > maxWidth / maxHeight) {
            //     // 更宽，按照宽度限定尺寸
            targetWidth = maxWidth;
            targetHeight = Math.round(maxWidth * (originHeight / originWidth));
            //   } else {
            //     targetHeight = maxHeight;
            //     targetWidth = Math.round(maxHeight * (originWidth / originHeight));
            //   }
            // }

            // canvas对图片进行缩放
            canvas.width = targetWidth;
            canvas.height = targetHeight;
            // 清除画布
            context.clearRect(0, 0, targetWidth, targetHeight);
            // 图片压缩
            context.drawImage(img, 0, 0, targetWidth, targetHeight);
            // canvas转为blob并上传
            canvas.toBlob(function (blob) {
              //在这里实现上传操作
              blob.name = file.name;
              editorUpload(blob).then(response=>{
                //console.log(response);
                self.editor.insertEmbed(self.editor.getSelection().index, 'image', response.data.url);
              })
            }, file.type || 'image/png');
          }
        };
      },
      /*裁切上传成功 res根据上传接口值获取*/
      onUploadSuccess:function (res) {
        this.editor.focus();
        this.editor.insertEmbed(this.editor.getSelection().index, 'image', res.url);
      },
      /*点击上传图片按钮*/
      imgClick() {
        if(this.canCrop){
          this.showCrop=true;
        }else{
          /*创建input file 不裁切，自己控制*/
          var input = document.createElement('input');
          input.type = 'file';
          input.name = this.fileName;
          input.accept = 'image/jpeg,image/png,image/jpg,image/gif';
          input.onchange = this.onFileChange;
          input.click();
        }
      },
    },
    watch: {
      content(val) {
        this.myContent = val;
      },
      myContent(val){
        this.$emit("on-content-change",val);
      }
    },
    computed: {
      editor() {
        return this.$refs.myTextEditor.quill;
      }
    },
    mounted() {
    },
    components: {
      quillEditor,
      //CropUpload
    },
  }
</script>

<style scoped>
  .ql-toolbar.ql-snow {
    line-height: 20px !important;
    padding: 4px !important;
  }

  .ql-toolbar.ql-snow .ql-formats{
    margin-right: 3px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/QuillEditor.vue